import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'quoteIcon',
    theme => `
		color: ${theme.survey.quote};
		width: 50px;
		height: 50px;
		margin-bottom: 5px;
	`
  ]
]);
